import { createMuiTheme } from '@material-ui/core/styles';
import { createTheme, createColor } from '@manakin/theme';
import { beautySecondary, white, grey, mountain, black } from '../colors';
import amber from '@material-ui/core/colors/amber';
import blue from '@material-ui/core/colors/blue';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import loginBackgroundImage from '../../assets/login-background.jpg';
import accountBackgroundImage from '../../assets/account-background.jpg';
import logo from '../../assets/logo.svg';
import pdfIcon from '../../assets/pdf.svg';
import loginVisual from '../../assets/login-visual.svg';
import footerLogo from '../../assets/logo.svg';
import calendarVisual from '../../assets/calendar-visual.svg';
import reportVisual from '../../assets/report-visual.svg';
const yellow = createColor('#c9e7e9');
const green = createColor('#3e9618');

const theme = (obj = {}) => {
	const homePageBlockPrimaryBackgroundColor = obj.homePageBlockPrimaryBackgroundColor;
	const homePageBlockSecondaryBackgroundColor = obj.homePageBlockSecondaryBackgroundColor;

	let _obj = {};

	_obj._primary = '#C9E7E9';
	_obj._secondary = '#5b7e6b';
	_obj._tertiary = '#F28F7F';
	_obj._palette = obj.themeColor || '#5b7e6b';
	_obj.indication = obj.indicationColor || '#000';
	_obj._primaryWorkform = '#C9E7E9';
	_obj._secondaryWorkform = '#27424B';
	_obj._buttonBorderColor = obj.buttonBorderColor || '#000000';
	_obj.buttonRadius = obj.buttonBorderRadius || '0px';

	//dynamic colors
	_obj.defaultBox = obj.defaultBoxColor || _obj._secondary;
	_obj.defaultElement = obj.defaultWorkformColor || obj.defaultElementColor || _obj._secondary;
	_obj.primaryElement = obj.primaryWorkformColor || _obj._primary;
	_obj.secondaryElement = obj.defaultWorkformColor || obj.secondaryElementColor || _obj._secondaryWorkform;
	_obj.defaultWorkform = obj.defaultWorkformColor || _obj._palette;
	_obj.primaryWorkform = obj.primaryWorkformColor || _obj._palette;
	_obj.secondaryWorkform = obj.secondaryWorkformColor || _obj._secondaryWorkform;
	_obj.buttonBorderColor = createColor(_obj._buttonBorderColor);

	///////COLORS
	_obj.createdPalette = createColor(_obj._palette);
	_obj.indicationColor = createColor(_obj.indication);
	_obj.defaultBoxColor = createColor(_obj.defaultBox);

	//ELEMENT COLORS
	_obj.defaultElementColor = createColor(_obj.defaultElement);
	_obj.primaryElementColor = createColor(_obj.primaryElement);
	_obj.secondaryElementColor = createColor(_obj.secondaryElement);

	//WORKFORM COLORS
	_obj.defaultWorkformColor = createColor(_obj.defaultWorkform);
	_obj.primaryWorkformColor = createColor(_obj.primaryWorkform);
	_obj.secondaryWorkformColor = createColor(_obj.secondaryWorkform);

	//primary and secondary colors
	_obj.primaryColor = createColor(_obj._primary);
	_obj.secondaryColor = createColor(_obj._secondary);
	_obj.tertiaryColor = createColor(_obj._tertiary);
	_obj.mountainColor = createColor(mountain);

	//Palette colors (Used for buttons, icons, navigation enz)
	_obj.primaryPaletteColor = black;
	_obj.secondaryPaletteColor = beautySecondary;

	//type colors
	_obj.typeColor = _obj._tertiary;
	_obj.primaryTypeColor = white;
	_obj.secondaryTypeColor = black;

	//box backgroundColors
	_obj.defaultBoxBGColor = _obj.primaryColor;

	//box name colors
	_obj.defaultBoxColor = black;
	_obj.primaryBoxColor = white;
	_obj.secondaryBoxColor = black;

	//element colors
	_obj.defaultElementBGColor = _obj.defaultElementColor;
	_obj.primaryElementBGColor = _obj.primaryElementColor;
	_obj.secondaryElementBGColor = _obj.secondaryElementColor;

	//backgroundColors
	_obj.defaultBackgroundColor = _obj.primaryColor;
	_obj.defaultTitleColor = black;
	_obj.defaultContentColor = createColor('#151b1e');
	_obj.homeLinkColor = _obj.defaultContentColor;
	_obj.secondaryBackgroundColor = grey;

	//Menu colors
	_obj.mainMenuBackground = _obj.primaryPaletteColor;
	_obj.mainMenuColor = beautySecondary;
	_obj.mainMenuSecondaryColor = white;

	//navigation colors
	_obj.navigationColor = _obj.primaryPaletteColor;
	_obj.secondaryNavigationColor = _obj.primaryPaletteColor;
	_obj.linkColor = _obj.primaryPaletteColor;
	_obj.defaultContentHover = _obj.createdPalette;
	_obj.LessonButtonColor = black;
	_obj.defaultBorderHoverColor = _obj.createdPalette;

	//rest
	_obj.defaultBorderColor = createColor('#E6E6E6');
	_obj.softBorderColor = createColor('#EFEFEF');
	_obj.subHeaderColor = createColor('#8A8A8A');
	_obj.correctAnswer = yellow;
	_obj.loginBackground = createColor('#F5F5F5');
	_obj.homePageBlockPrimaryBackgroundColor = createColor(homePageBlockPrimaryBackgroundColor) || obj.primaryWorkform;
	_obj.homePageBlockSecondaryBackgroundColor = createColor(homePageBlockSecondaryBackgroundColor) || obj.secondaryWorkform;

	_obj.contentWidthXL = '1600px';
	_obj.contentWidthL = '1200px';
	_obj.contentWidthM = '1050px';
	_obj.contentWidthS = '700px';
	_obj.contentWidthXS = '340px';
	//breakpoints
	_obj.smartphoneBreakpoint = '@media only screen and (min-width : 375px)';
	_obj.tabletPortraitBreakpoint = '@media only screen and (min-width : 768px)';
	_obj.tabletLandscapeBreakpoint = '@media only screen and (min-width : 1024px)';
	_obj.laptopBreakpoint = '@media only screen and (min-width : 1280px)';
	_obj.desktopBreakpoint = '@media only screen and (min-width : 1400px)';
	_obj.desktopXLBreakpoint = '@media only screen and (min-width : 2100px)';

	//margins and paddings
	_obj.mainMenuListItemPaddingTop = '25px';
	_obj.mainMenuListItemPaddingBottom = '25px';
	_obj.defaultPadding = '25px';

	//fonts
	_obj.defaultTitleFont = 'Neue haas bold';
	_obj.secondaryTitleFont = 'Neue haas bold';
	_obj.workformQuestionFont = 'GT super display';
	_obj.defaultAnswerFont = 'Neue haas';
	_obj.defaultContentFont = 'Neue haas';

	_obj.workformTitleFont = {
		fontFamily: _obj.defaultTitleFont,
		fontSize: '4rem',
		lineHeight: '130%',
		letterSpacing: 0,
		fontWeight: 500,
	};

	//heights
	_obj.defaultMobileMenuHeight = '64px';
	_obj.defaultDesktopMenuHeight = '100px';

	_obj.defaultWrapper = {
		maxWidth: _obj.contentWidthM,
		position: 'relative',
		margin: '0 auto',
		width: '100%',
		paddingLeft: '25px',
		paddingRight: '25px',
	};
	_obj.extraSmallWrapper = {
		..._obj.defaultWrapper,
		maxWidth: _obj.contentWidthXS,
	};
	_obj.smallWrapper = {
		..._obj.defaultWrapper,
		maxWidth: _obj.contentWidthS,
	};
	_obj.largeWrapper = {
		..._obj.defaultWrapper,
		maxWidth: _obj.contentWidthL,
	};
	_obj.extraLargeWrapper = {
		..._obj.defaultWrapper,
		maxWidth: _obj.contentWidthXL,
	};

	_obj.footerLogoStyle = {
		width: '10rem',
		height: '3rem',
		backgroundImage: `url(${footerLogo})`,
		backgroundSize: 'contain',
		backgroundRepeat: 'no-repeat',
		position: 'absolute',
		right: '10rem',
		bottom: '3rem',
	};

	_obj.registrationHeading = {
		large: {
			textAlign: 'center',
			width: '100%',
			maxWidth: '600px',
			fontSize: '40px',
			lineHeight: '130%',
			margin: '0 auto 1em',
		},
		small: {
			fontSize: '28px',
			letterSpacing: '.2rem',
		},
	};

	_obj.listStyle = {
		'& ol, & ul': {
			padding: 0,
			counterReset: 'li-index',
			listStyle: 'none',
		},
		'& li': {
			position: 'relative',
			paddingLeft: '2.75rem',
		},
		'& li::before': {
			content: "''",
			position: 'absolute',
			top: 0,
			left: 0,
		},
		'& ul li::before': {
			top: '12px',
			width: '8px',
			height: '8px',
			background: 'currentColor',
			borderRadius: '50%',
		},
		'& ol li::before': {
			counterIncrement: 'li-index',
			content: 'counter(li-index)',
		},
	};

	_obj.breakpoints = createBreakpoints({});

	const realTheme = _theme(_obj);

	return realTheme;
};

const _theme = (props) =>
	createMuiTheme({
		typography: {
			htmlFontsize: 10,
			fontFamily: [
				props.defaultContentFont,
				'-apple-system',
				'BlinkMacSystemFont',
				'"Segoe UI"',
				'Roboto',
				'"Helvetica Neue"',
				'Arial',
				'sans-serif',
				'"Apple Color Emoji"',
				'"Segoe UI Emoji"',
				'"Segoe UI Symbol"',
			].join(','),
		},
		palette: {
			primary: props.primaryPaletteColor,
			secondary: props.secondaryPaletteColor,
			success: {
				light: green[200],
				main: green[400],
				dark: green[600],
				contrastText: '#ffffff',
			},
			info: {
				light: blue[300],
				main: blue[400],
				dark: blue[500],
				contrastText: '#ffffff',
			},
			warning: {
				light: amber[400],
				main: amber[600],
				dark: amber[700],
				contrastText: '#ffffff',
			},
		},
		manakin: createTheme({
			accountBackgroundImage: accountBackgroundImage,
			calendarVisual: calendarVisual,
			correctAnswer: props.correctAnswer,
			defaultActiveColor: green,
			defaultAnswerFont: props.defaultAnswerFont,
			defaultBackgroundColor: props.defaultBackgroundColor,
			defaultBorderColor: props.defaultBorderColor,
			defaultBorderHoverColor: props.defaultBorderHoverColor,
			defaultBoxBGColor: props.defaultBoxBGColor,
			defaultBoxColor: props.defaultBoxColor,
			defaultButtonBorderColor: props.buttonBorderColor,
			defaultButtonRadius: props.buttonRadius,
			defaultContentColor: props.defaultContentColor,
			defaultContentFont: props.defaultContentFont,
			defaultContentHover: props.defaultContentHover,
			defaultDesktopMenuHeight: props.defaultDesktopMenuHeight,
			defaultElementBGColor: props.defaultElementBGColor,
			defaultMobileMenuHeight: props.defaultMobileMenuHeight,
			defaultPadding: props.defaultPadding,
			defaultTitleColor: props.defaultTitleColor,
			defaultTitleFont: props.defaultTitleFont,
			defaultWorkformColor: props.defaultWorkformColor,
			defaultWrapper: props.defaultWrapper,
			desktopBreakpoint: props.desktopBreakpoint,
			desktopXLBreakpoint: props.desktopXLBreakpoint,
			extraLargeWrapper: props.extraLargeWrapper,
			extraSmallWrapper: props.extraSmallWrapper,
			homeLinkColor: props.homeLinkColor,
			homePageBlockPrimaryBackgroundColor: props.homePageBlockPrimaryBackgroundColor,
			homePageBlockSecondaryBackgroundColor: props.homePageBlockSecondaryBackgroundColor,
			indicationColor: props.indicationColor,
			laptopBreakpoint: props.laptopBreakpoint,
			largeWrapper: props.largeWrapper,
			layoutButtonStyleSelected: {
				backgroundColor: props.primaryPaletteColor[500],
				border: 0,
				color: white[500],
			},
			LessonButtonColor: props.LessonButtonColor,
			linkColor: props.linkColor,
			loginBackground: props.loginBackground,
			loginBackgroundImage: loginBackgroundImage,
			loginVisual: loginVisual,
			logo: logo,
			mainMenuBackground: props.mainMenuBackground,
			mainMenuColor: props.mainMenuColor,
			mainMenuListItemPaddingBottom: props.mainMenuListItemPaddingBottom,
			mainMenuListItemPaddingTop: props.mainMenuListItemPaddingTop,
			mainMenuSecondaryColor: props.mainMenuSecondaryColor,
			navigationColor: props.navigationColor,
			pdfIcon: pdfIcon,
			primaryBoxColor: props.primaryBoxColor,
			primaryColor: props.primaryColor,
			primaryElementBGColor: props.primaryElementBGColor,
			primaryPaletteColor: props.primaryPaletteColor,
			primaryTypeColor: props.primaryTypeColor,
			primaryWorkformColor: props.primaryWorkformColor,
			reportVisual: reportVisual,
			secondaryBackgroundColor: props.secondaryBackgroundColor,
			secondaryBoxColor: props.secondaryBoxColor,
			secondaryColor: props.secondaryColor,
			secondaryElementBGColor: props.secondaryElementBGColor,
			secondaryNavigationColor: props.secondaryNavigationColor,
			secondaryTitleFont: props.secondaryTitleFont,
			secondaryTypeColor: props.secondaryTypeColor,
			secondaryWorkformColor: props.secondaryWorkformColor,
			smallWrapper: props.smallWrapper,
			smartphoneBreakpoint: props.smartphoneBreakpoint,
			softBorderColor: props.softBorderColor,
			subHeaderColor: props.subHeaderColor,
			tabletLandscapeBreakpoint: props.tabletLandscapeBreakpoint,
			tabletPortraitBreakpoint: props.tabletPortraitBreakpoint,
			tertiaryColor: props.tertiaryColor,
			typeColor: props.typeColor,
			underline: {
				width: '50px',
				height: '2px',
				backgroundColor: props.defaultContentColor[500],
				position: 'absolute',
				bottom: 0,
				left: '50%',
				transform: 'translate(-50%, 2.5rem)',
			},
			visual: {
				backgroundImage: `url(${loginVisual})`,
				width: '100%',
				height: '100%',
				backgroundSize: 'cover',
			},
			workformTitleFont: props.workformTitleFont,
		}),
		overrides: {
			AccordionFaq: {
				panelHeading: {
					color: 'black',
				},
				content: {
					color: 'black',
				},
				panelRoot: {
					backgroundColor: props.secondaryBackgroundColor[500],
				},
			},
			AppAccount: {
				deleteButton: {
					color: 'red',
				},
				confirmDeleteButton: {
					backgroundColor: 'red',
				},
			},
			AppAccountWrapper: {
				root: {
					background: 'none',
				},
				title: {
					letterSpacing: '0rem',
				},
			},
			AppAssignmentCardView: {
				label: {
					'&:not($disabled)': {
						'&:hover': {
							background: 'black',
							color: 'white',
						},
					},
				},
			},
			AppBar: {
				menuText: {
					color: black[500],
				},
				dropdownInput: {
					fontSize: '1.4rem',
					letterSpacing: '.3rem',
					fontFamily: props.secondaryTitleFont,
					fontWeight: 'bold',
				},
				programsDropdownRoot: {
					[props.breakpoints.down('sm')]: {
						left: '25px',
						right: '25px',
						width: 'auto',
						marginTop: '120px',
						transform: 'none',
					},
				},
				menuButtonLabel: {
					fontSize: '2rem',
					fontWeight: 500,
					marginLeft: '22px',
				},
				iconColor: {
					color: props.mountainColor[500],
				},
				buttonRoot: {
					marginLeft: '1rem',
					color: props.mountainColor[500],
				},
				buttonLabel: {
					color: props.mountainColor[500],
				},
				secondaryColors: {
					'& $menuText': {
						color: props.mountainColor[500],
					},
					'& $iconColor': {
						color: props.mountainColor[500],
					},
					'& $backButtonRoot': {
						color: props.mountainColor[500],
					},
					'& $buttonLabel': {
						color: props.mountainColor[500],
					},
				},
			},
			appBestTimes: {
				user: {
					backgroundColor: props.primaryColor[500],
				},
				body: {
					color: white[500],
				},
				currentUser: {
					backgroundColor: props.primaryPaletteColor[500],
					'& $body': {
						color: white[500],
					},
					'& $time': {
						color: white[500],
					},
				},
			},
			AppBettingGameFrontPageBody: {
				root: {
					backgroundColor: white[500],
				},
			},
			AppBettingGameQuestions: {
				points: {
					backgroundColor: props.primaryPaletteColor[500],
					borderRadius: '100%',
				},
			},
			AppBookCheckHeader: {
				headingRoot: {
					letterSpacing: 0,
				},
			},
			AppBox: {
				footerLogo: {
					right: '12rem',
					bottom: '-39px',
				},
			},
			AppBoxCard: {
				backgroundImage: {
					transform: 'scale(1.1)',
				},
				inner: {
					padding: '2.25rem',
					[props.breakpoints.up('md')]: {
						height: '40rem',
						padding: '0 6rem',
					},
					'&:hover': {
						'& $backgroundImage': {
							transform: 'translateX(2%) scale(1.1)',
						},
						'& $overflow': {
							transform: 'scale(1) translate(2%, -20px)',
						},
						'& $boxDescription': {
							visibility: 'visible',
							transform: 'none',
							opacity: 1,
						},
						'& $boxSubtitle': {
							display: 'none',
						},
						'& $boxName': {
							opacity: 0,
							visibility: 'hidden',
							transform: 'translateY(-32px)',
						},
						'& $boxCardLabel': {
							transform: 'none',
						},
					},
				},
				innerDone: {
					[props.breakpoints.up('md')]: {
						height: '30rem',
					},
				},
				boxName: {
					fontWeight: '700',
					fontFamily: props.defaultTitleFont,
					transition: 'all .2s ease',
					fontSize: '2rem',
					paddingLeft: 0,
					[props.breakpoints.up('md')]: {
						fontSize: '4.4rem',
						lineHeight: '5.5rem',
						maxWidth: '50%',
					},
				},
				boxCardIconLabel: {
					backgroundColor: white[500],
				},
				boxDescription: {
					position: 'absolute',
					marginTop: 0,
					visiblity: 'hidden',
					opacity: 0,
					transform: 'translateY(32px)',
					transition: 'all .2s ease',
				},
				boxCardText: {
					color: black[500],
					[props.breakpoints.up('md')]: {
						fontSize: '1.4rem',
					},
				},
				withOverflow: {},
				listView: {
					borderRadius: 0,
					'&$withOverflow': {
						'&::before': {
							content: "''",
							position: 'absolute',
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
							backgroundColor: 'white',
						},
						'& $backgroundImage': {
							backgroundColor: 'inherit',
						},
					},
					'& $boxName': {
						letterSpacing: 0,
						[props.breakpoints.up('md')]: {
							letterSpacing: 0,
						},
					},
					'&:hover': {
						'& $boxName': {
							opacity: 1,
							transform: 'translateY(0)',
							visibility: 'visible',
						},
					},
				},
				boxRootOverflow: {},
				listViewRoot: {
					'&$boxRootOverflow': {
						marginTop: 0,
					},
					'& $withOverflow': {
						overflow: 'hidden',
					},
					'& $overflow': {
						height: '100%',
						transform: 'scale(1.1)',
					},
					'& $withOverflow:hover': {
						'& $backgroundImage': {
							transform: 'translateX(2%) scale(1.1)',
						},
					},
				},
				percentage: {
					fontSize: '1.4rem',
					letterSpacing: 0,
					width: '4rem',
					height: '4rem',
					[props.breakpoints.up('md')]: {
						fontSize: '1.4rem',
						width: '4rem',
						height: '4rem',
					},
				},
				percentageDone: {
					backgroundColor: black[500],
					color: white[500],
				},
			},
			AppBoxes: {
				wrapper: {
					maxWidth: '1250px',
				},
				smallWrapper: {
					backgroundColor: 'transparent',
					[props.breakpoints.down('md')]: {
						backgroundColor: 'white',
						paddingTop: '20px',
					},
				},
			},
			AppBoxHeader: {
				root: {
					backgroundColor: '#F6F3EA',
					[props.breakpoints.up('md')]: {
						paddingBottom: '30rem',
					},
				},
				heading: {
					color: black[500],
					lineHeight: '4rem',
					textTransform: 'none',
					[props.breakpoints.up('md')]: {
						lineHeight: '5rem',
					},
				},
				body: {
					color: black[500],
				},
				resultsPercentage: {
					'&::after': {
						background: `linear-gradient(90deg, rgba(252,122,76,1) 0%, rgba(252,122,76,1) 25%, rgba(252,122,76,0) 25%, rgba(252,122,76,0) 75%, rgba(252,122,76,1) 75%, rgba(252,122,76,1) 100%)`,
						letterSpacing: 0,
						width: '150px',
						color: props.primaryPaletteColor[500],
					},
				},
			},
			AppBoxLayout: {
				wrapper: {
					[props.breakpoints.up('md')]: {
						paddingBottom: '4rem',
					},
				},
				root: {
					position: 'relative',
					paddingBottom: '10rem',
					[props.breakpoints.up('md')]: {
						marginTop: '-28.5rem',
						paddingBottom: '14rem',
					},
				},
				footerLogo: {
					...props.footerLogoStyle,
					backgroundImage: 'none',
					right: '12rem',
				},
				listView: {
					backgroundColor: 'transparent',
					paddingBottom: '0',
				},
			},
			AppCaseContent: {
				closeButtonRedo: {
					backgroundColor: props.primaryWorkformColor[100],
					color: black[500],
					margin: 0,
					'&:hover': {
						backgroundColor: props.primaryWorkformColor[50],
						color: black[500],
					},
				},
				closeButtonClose: {
					backgroundColor: props.primaryWorkformColor[500],
					color: white[500],
					margin: 0,
					'&:hover': {
						backgroundColor: props.primaryWorkformColor[400],
						color: white[500],
					},
				},
				question: {
					[props.breakpoints.up('md')]: {
						maxWidth: '1280px',
					},
				},
			},
			AppChoiceQuestion: {
				header: {
					fontFamily: props.workformQuestionFont,
				},
				subHeader: {
					fontFamily: props.secondaryTitleFont,
					color: black[500],
					fontSize: '1.4rem',
					padding: '0 0 .75rem',
					[props.breakpoints.up('md')]: {
						fontSize: '2rem',
					},
					'&::after': {
						backgroundColor: props.primaryPaletteColor[500],
					},
				},
			},
			AppClassList: {
				topBar: {
					backgroundColor: props.secondaryBackgroundColor[500],
				},
			},
			AppContentHeader: {
				title: {
					letterSpacing: '0rem',
				},
			},
			AppDashboardHeader: {
				root: {
					backgroundColor: '#F6F3EA', //hier
					[props.breakpoints.up('md')]: {
						padding: '18rem 0 30rem',
					},
				},
			},
			AppDownloadButton: {
				wrapper: {
					maxWidth: '1020px',
				},
			},
			AppElementCard: {
				videoBG: {
					maxHeight: '410px',
					marginBottom: '-10px',
				},
				contentColor: {},
				backgroundImage: {
					transition: 'width .3s, height .3s, background-color .3s',
				},
				root: {
					borderRadius: 0,
					'&:hover': {
						'& $backgroundImage': {
							[props.breakpoints.up('md')]: {
								transform: 'scale(1)',
								height: 'calc(100% + 30px)',
							},
						},
					},
				},
				name: {
					letterSpacing: 0,
					fontWeight: 500,
					fontFamily: props.defaultTitleFont,
					[props.breakpoints.up('md')]: {
						fontSize: '2.4rem',
						letterSpacing: 0,
						lineHeight: '2.4rem',
					},
				},
				type: {
					fontFamily: props.defaultAnswerFont,
					marginBottom: '1rem',
					fontSize: '1.8rem',
					fontWeight: '500',
				},
				body: {},
				bodytitle: {},
				bookCheck: {
					backgroundColor: '#3b7186',
					[props.breakpoints.up('md')]: {
						minHeight: '20rem',
					},
				},
				bookCheckContent: {
					'& $bodytitle': {
						color: 'white',
					},
					'& $body': {
						margin: 0,
						lineHeight: '1.25',
						color: 'white',
					},
				},
				button: {
					backgroundColor: 'transparent',
					color: 'black',
					border: `3px solid white`,
					minHeight: '3rem',
					padding: '1.8rem!important',
					'& span': {
						fontSize: '1.8rem',
						color: 'white',
					},
				},
				// doneIcon: {
				// 	color: '#000000',
				// },
				done: {
					backgroundColor: 'transparent',
					[props.breakpoints.up('md')]: {
						width: '4rem',
						height: '4rem',
					},
				},
				inCorrect: {
					backgroundColor: 'transparent',
				},
				primaryTitleColor: {
					color: white[500],
				},
				bridgeContent: {
					[props.breakpoints.up('md')]: {
						padding: '80px 60px',
					},
					'& $contentColor': {
						'&>ul': {
							paddingLeft: '2rem',
							marginTop: '2rem',
							[props.breakpoints.up('md')]: {
								paddingLeft: '2rem',
							},
						},
					},
				},
				fullWidth: {
					[props.breakpoints.up('md')]: {
						'&$bookCheck': {
							'& $backgroundImage': {
								width: '20rem',
							},
							padding: '2.5rem 5rem 2.5rem 24rem',
						},
					},
				},
				minHeight: {
					[props.breakpoints.up('md')]: {
						minHeight: '400px',
					},
					'& $done': {
						[props.breakpoints.up('md')]: {
							top: '2rem',
							right: '2rem',
						},
					},
				},
			},
			AppElementOverlay: {
				title: {
					fontFamily: props.defaultTitleFont,
					fontWeight: 'bold',
				},
				closeButton: {
					backgroundColor: black[500],
					color: 'white',
					'&:hover': {
						backgroundColor: black[500],
						color: 'white',
					},
				},
			},
			AppElementsRoot: {
				grid: {
					marginTop: '-5rem',
					maxWidth: '1230px',
					[props.breakpoints.up('md')]: {
						marginTop: '-28rem',
					},
				},
			},
			AppFactcardReferral: {
				root: {
					borderRadius: '0',
					overflow: 'hidden',
					maxWidth: '1200px',
					margin: '0 auto',
				},
				title: {
					fontSize: '2.4rem',
					marginBottom: '1rem',
				},
				body: {
					lineHeight: 1.25,
				},
				multi: {
					'& $title': {
						marginBottom: '.4rem',
					},
					'& $body': {
						marginBottom: '3rem',
					},
				},
				button: {
					backgroundColor: 'transparent',
					border: '3px solid white',
					minHeight: '3rem',
					padding: '1.8rem!important',
					[props.breakpoints.up('md')]: {
						minWidth: '27rem',
					},
					'& span': {
						fontSize: '1.8rem',
					},
				},
			},
			AppFactcardsCard: {
				root: {
					borderRadius: '0',
				},
				name: {
					letterSpacing: 0,
					fontWeight: 500,
					fontFamily: props.groldBold,
					[props.breakpoints.up('md')]: {
						fontSize: '3.2rem',
						letterSpacing: 0,
						lineHeight: '5rem',
					},
				},
				backgroundImage: {},
				bodytitle: {
					marginBottom: '1rem',
					color: 'black',
				},
				body: {
					color: 'black',
				},
				bookCheck: {
					backgroundColor: props.primaryColor[500],
					'& $backgroundImage': {
						[props.breakpoints.up('md')]: {
							width: '20rem',
						},
					},
					[props.breakpoints.up('md')]: {
						height: '20rem',
						padding: '2.5rem 5rem 2.5rem 24rem',
					},
				},
				bookCheckContent: {
					'& $body': {
						margin: 0,
					},
				},
				button: {
					backgroundColor: 'transparent',
					minHeight: '3rem',
					padding: '1.8rem!important',
					[props.breakpoints.up('md')]: {
						minWidth: '27rem',
					},
					'& span': {
						fontSize: '1.8rem',
						color: 'black',
					},
					'&:hover': {
						borderColor: 'white',
						'& span': {
							color: 'white',
						},
					},
				},
				factCardsButton: {
					borderColor: props.buttonBorderColor[500],
				},
			},
			AppFactCardTitles: {
				content: {
					...props.listStyle,
				},
			},
			AppFirstPage: {
				wrapper: {
					maxWidth: props.contentWidthM,
				},
				titleRoot: {
					[props.breakpoints.up('md')]: {
						fontSize: '6rem',
						lineHeight: '7rem',
						letterSpacing: '.4rem',
					},
					[props.breakpoints.up('lg')]: {
						fontSize: '6rem',
						lineHeight: '7rem',
						letterSpacing: '.4rem',
					},
				},
			},
			AppHotspotMapLandscape: {
				subHeader: {
					fontFamily: props.secondaryTitleFont,
					color: black[500],
					fontSize: '1.4rem',
					padding: '0 0 .75rem',
					[props.breakpoints.up('md')]: {
						fontSize: '2rem',
					},
					'&::after': {
						backgroundColor: props.primaryPaletteColor[500],
					},
				},
				question: {
					fontFamily: props.workformQuestionFont,
				},
				container: {
					maxWidth: '1200px',
					margin: '0 auto',
				},
			},
			AppImageWithSubtitle: {
				image: {
					maxWidth: '1020px',
					margin: '0 auto',
				},
				content: {
					maxWidth: '1200px',
					margin: '0 auto',
				},
			},
			AppLayoutButtons: {
				label: {
					color: '#000000',
					textTransform: 'uppercase',
					fontFamily: props.groldBold,
					letterSpacing: '3px',
				},
				tabsRoot: {
					marginBottom: '4rem',
				},
				tabSelected: {
					backgroundColor: black[500],
				},
			},
			AppLesson: {
				largeWrapper: {
					maxWidth: '1230px',
					[props.breakpoints.up('md')]: {
						maxWidth: '1230px',
					},
				},
				normalMargin: {
					margin: '3rem 0',
					[props.breakpoints.up('md')]: {
						margin: '8rem 0',
					},
				},
			},
			AppLessonBottom: {
				root: {
					backgroundColor: white[500],
					borderTop: `1px solid ${props.defaultBorderColor[500]}`,
				},
				button: {
					margin: '0 1rem',
					minWidth: '300px',
					fontFamily: props.defaultTitleFont,
					backgroundColor: props.secondaryColor[500],
					[props.breakpoints.up('md')]: {
						height: '34rem',
					},
					'&:hover': {
						backgroundColor: props.secondaryColor[700],
					},
				},
				backToBoxButton: {
					display: 'none',
				},
				redoQuestionButton: {
					display: 'flex',
					color: white[500],
				},
				nextQuestionButton: {
					display: 'flex',
				},
			},
			AppLessonHeader: {
				fontStyle: {
					textTransform: 'uppercase',
					fontSize: '22px',
					fontFamily: props.defaultContentFont,
				},
				heading: {
					fontSize: '6rem',
					letterSpacing: '1.2px',
				},
			},
			AppLessonIntroduction: {
				content: {
					letterSpacing: '.1rem',
					'&:first-letter': {
						color: props.defaultTitleColor[500],
						fontSize: '2rem',
						lineHeight: '3.6rem',
						fontWeight: '600',
						'&:first-letter': {
							fontSize: '12rem',
							lineHeight: '12rem',
							margin: '0 6rem 0 0',
						},
					},
					[props.breakpoints.up('md')]: {
						fontSize: '1.8rem',
						lineHeight: '2.8rem',
						minHeight: '154px',
					},
				},
			},
			AppLogin: {
				fontSize: '1.8rem',
				root: {
					display: 'flex',
					flexDirection: 'column',
					[props.breakpoints.up('lg')]: {
						marginTop: '9rem',
					},
				},
				registrationLink: {
					order: 3,
					marginTop: '5rem',
				},
			},
			appLoginHeader: {
				root: {
					background: props.primaryColor[500],
					[props.breakpoints.up('lg')]: {
						background: 'linear-gradient(to right, #ffffff 0%,#ffffff 25%,#c9e7e9 25%,#c9e7e9 100%)',
					},
				},
				content: {
					backgroundPosition: 'center bottom',
					backgroundSize: '745px',
				},
				login: {
					backgroundColor: 'white',
					[props.breakpoints.up('md')]: {
						maxWidth: '500px',
					},
				},
				visual: {
					display: 'none',
				},
				logo: {
					width: '315px',
					height: '76px',
					position: 'static',
					backgroundImage: `url(${logo})`,
					backgroundSize: 'contain',
					backgroundRepeat: 'no-repeat',
					[props.breakpoints.down('md')]: {
						width: '215px',
						height: '56px',
						marginTop: '50px',
					},
				},
				visualTitle: {
					color: 'black',
					[props.breakpoints.up('md')]: {
						transformOrigin: 'left center',
						transform: 'rotate(-90deg)',
						fontSize: '4.8rem',
						left: '50%',
						bottom: '7rem',
						marginLeft: '-680px',
					},
				},
				AppBoxes: {
					wrapper: {
						maxWidth: '1250px',
					},
					smallWrapper: {
						backgroundColor: 'transparent',
						[props.breakpoints.down('md')]: {
							backgroundColor: 'white',
							paddingTop: '20px',
						},
					},
				},
			},
			AppLogout: {
				root: {
					backgroundColor: 'white',
				},
			},
			AppMenu: {
				link: {
					color: white[500],
				},
			},
			AppMoodboard: {
				root: {
					maxWidth: '1200px',
					margin: '0 auto',
				},
				card: {
					padding: '2rem',
					[props.breakpoints.up('md')]: {
						padding: '2rem',
					},
				},
			},
			AppPointsInfo: {
				pointsBody: {
					color: props.primaryPaletteColor.contrastText,
				},
				pointsTitle: {
					color: props.primaryPaletteColor.contrastText,
				},
			},
			appPointsPopup: {
				heading: {
					paddingRight: '30px',
				},
				nextCategory: {
					color: props.defaultContentColor[500],
				},
				points: {
					backgroundColor: props.primaryPaletteColor[500],
					borderRadius: '100%',
				},
				pointsBody: {
					color: props.primaryPaletteColor.contrastText,
				},
			},
			AppProfilePicture: {
				editPicture: {
					color: white[500],
				},
			},
			AppRadioGroup: {
				formControlLabel: {
					[props.breakpoints.up('md')]: {
						fontSize: '1.8rem',
					},
				},
			},
			AppRegistrationAuthData: {
				heading: {
					...props.registrationHeading.large,
					[props.breakpoints.down('md')]: {
						...props.registrationHeading.small,
					},
				},
			},
			AppRegistrationPersonalData: {
				heading: {
					...props.registrationHeading.large,
					[props.breakpoints.down('md')]: {
						...props.registrationHeading.small,
					},
				},
			},
			AppRegistrationSchoolClassData: {
				heading: {
					...props.registrationHeading.large,
					[props.breakpoints.down('md')]: {
						...props.registrationHeading.small,
					},
				},
			},
			AppRegistrationSchoolData: {
				heading: {
					...props.registrationHeading.large,
					[props.breakpoints.down('md')]: {
						...props.registrationHeading.small,
					},
				},
			},
			AppRegistrationScreen: {
				root: {
					minHeight: '100vh',
					backgroundColor: white[500],
				},
				heading: {
					textAlign: 'center',
				},
			},
			AppRegistrationSuccess: {
				content: {
					margin: '0 0 0px',
				},
				heading: {
					...props.registrationHeading.large,
					[props.breakpoints.down('md')]: {
						...props.registrationHeading.small,
					},
				},
			},
			AppResumeButton: {
				root: {
					backgroundColor: white[500],
					overflow: 'hidden',
					'&:hover': {
						'& $body1': {
							color: props.createdPalette[500],
						},
						'& $longArrow': {
							'& .arrow': {
								backgroundColor: props.createdPalette[500],
							},
						},
					},
				},
			},
			appRoadmap: {
				wrapper: {
					[props.breakpoints.up('lg')]: {
						padding: '0 9rem',
					},
				},
			},
			appRoadmapStep: {
				header: {
					textTransform: 'none',
					fontSize: '30px',
					lineHeight: '28px',
					paddingBottom: '2.4rem',
				},

				subHeader: {
					fontFamily: props.secondaryTitleFont,
					fontSize: '1.4rem',
					padding: '0 0 .75rem',
					[props.breakpoints.up('md')]: {
						fontSize: '2rem',
					},
				},
			},
			AppSearchInput: {
				root: {
					margin: 0,
				},
			},
			AppSliderInput: {
				sliderLabel: {
					fontSize: '16px',
				},
			},
			AppSortSlider: {
				questionContent: {
					[props.breakpoints.up('md')]: {
						fontSize: '1.8rem',
					},
				},
			},
			AppStatementQuestion: {
				subHeader: {
					fontFamily: props.secondaryTitleFont,
					color: black[500],
					fontSize: '1.4rem',
					padding: '0 0 .75rem',
					[props.breakpoints.up('md')]: {
						fontSize: '2rem',
					},
				},
				root: {
					borderRadius: '0',
					overflow: 'hidden',
					maxWidth: '1200px',
					margin: '0 auto',
				},
				quote: {
					fontFamily: props.defaultTitleFont,

					fontSize: '2.75rem',
					lineHeight: '1.25',
					letterSpacing: '1px',
				},
				button: {
					backgroundColor: 'transparent',
					border: '3px solid white',
					minHeight: '3rem',
					padding: '1.8rem!important',
					borderRadius: '0',
					[props.breakpoints.up('md')]: {
						minWidth: '16rem',
					},
					'& span': {
						fontSize: '1.8rem',
					},
				},
			},
			AppStatisticsBox: {
				statistics: {
					[props.breakpoints.up('md')]: {
						border: `1px solid black`,
					},
				},
				specificStatisticItem: {
					border: `1px solid ${props.primaryPaletteColor[100]}`,
					[props.breakpoints.up('md')]: {
						border: 0,
					},
				},
			},
			AppTeacherHeader: {
				root: {
					backgroundColor: props.secondaryBackgroundColor[500],
				},
				heading: {
					color: props.defaultTitleColor[500],
				},
				body: {
					color: props.defaultTitleColor[500],
				},
			},
			AppTeacherProgram: {
				root: {
					backgroundColor: props.secondaryBackgroundColor[500],
				},
				title: {
					letterSpacing: '0rem',
				},
			},
			AppTeacherReport: {
				root: {
					backgroundColor: props.secondaryBackgroundColor[500],
				},
				content: {
					'& $heading': {
						color: props.defaultTitleColor[500],
					},
				},
			},
			AppTestCard: {
				root: {
					borderRadius: '0',
				},
			},
			AppTitleAndText: {
				wrapper: {
					[props.breakpoints.up('lg')]: {
						padding: '0 9rem',
					},
				},
				root: {
					borderRadius: '0',
					maxWidth: '1200px',
					margin: '0 auto',
					[props.breakpoints.up('md')]: {
						padding: '10rem 0',
					},
				},
				header: {
					textTransform: 'none',
					fontSize: '30px',
					lineHeight: '28px',
					paddingBottom: '2.4rem',
				},
				content: {
					fontSize: '1.8rem',
					lineHeight: '3rem',
				},
				columns: {
					[props.breakpoints.up('md')]: {
						columnGap: '4rem',
					},
				},
			},
			AppTitleAndTextImage: {
				root: {
					maxWidth: '1200px',
					margin: '0 auto',
				},
				header: {
					textTransform: 'none',
					fontSize: '30px',
					lineHeight: '28px',
					paddingBottom: '2.4rem',
				},
				content: {
					fontSize: '1.8rem',
					lineHeight: '2.8rem',
					...props.listStyle,
				},
				secondary: {
					'& $contentColor': {
						color: white[500],
					},
				},
			},
			AppVideoPlayer: {
				activeIcon: {
					color: props.correctAnswer[500],
				},
				playButton: {
					'& $icon': {
						backgroundColor: props.primaryPaletteColor[500],
					},
				},
			},
			AppWorkformLayout: {
				header: {
					fontWeight: '500',
					marginBottom: '7rem',
					fontSize: '3.2rem',
					marginTop: '1.8rem',
					fontFamily: props.workformQuestionFont,
					// fontFamily: props.recoletaBold,
					color: black[500],
					[props.breakpoints.down('xs')]: {
						fontSize: '3rem',
					},
				},
				wrapper: {
					[props.breakpoints.up('md')]: {
						maxWidth: '100%',
					},
				},
				subHeader: {
					fontFamily: props.secondaryTitleFont,
					color: black[500],
					fontSize: '1.4rem',
					padding: '0 0 .75rem',
					[props.breakpoints.up('md')]: {
						fontSize: '2rem',
					},
					'&::after': {
						backgroundColor: props.primaryPaletteColor[500],
					},
				},
				secondaryColors: {
					'& $contentColor': {
						color: white[500],
					},
					'& $button': {
						color: white[500],
					},
				},
				container: {
					maxWidth: '100%',
				},
			},
			AuthenticationConfirmReset: {
				root: {
					background: white[500],
				},
			},
			AuthenticationLoginForm: {
				submit: {
					backgroundColor: props.primaryColor[500],
					color: 'black',
				},
			},
			AuthenticationResetPassword: {
				heading: {
					...props.registrationHeading.large,
					[props.breakpoints.down('md')]: {
						...props.registrationHeading.small,
					},
				},
			},
			ClaimLicense: {
				root: {
					width: '100%',
					height: '100%',
				},
			},
			HeaderFaq: {
				heading: {
					letterSpacing: '0rem',
				},
			},
			HelpButton: {
				fab: {
					backgroundColor: props.primaryColor[500],
					color: 'black',
					'&:hover': {
						color: 'white',
					},
				},
				icon: {
					marginTop: 0,
				},
			},
			ManakinLoginForm: {
				root: {
					backgroundColor: yellow[500],
				},
			},
			MuiBadge: {
				colorSecondary: {
					backgroundColor: 'red',
				},
			},
			MuiButton: {
				root: {
					zIndex: 1,
					color: 'white',
					height: 'auto',
					padding: '20px',
					borderRadius: '0',
				},
				contained: {
					boxShadow: 'none',
				},
				containedPrimary: {
					backgroundColor: 'black',
					color: 'white',
					transition: 'background-color .2s, color .2s',
					'&:hover': {
						backgroundColor: '#2d2d2d',
						color: 'white',
					},
				},
				label: {
					position: 'relative',
					textTransform: 'none',
					zIndex: 1,
					fontSize: '1.8rem',
					textDecoration: 'none',
				},
				outlinedPrimary: {
					border: '2px solid black',
					padding: '18px',
					'&:hover': {
						border: '2px solid black',
					},
				},
			},
			MuiChip: {
				label: {
					fontSize: '14px',
				},
			},
			MuiDialog: {
				paper: {
					margin: '18px',
					[props.breakpoints.up('md')]: {
						padding: '4.4rem 5rem 1rem',
					},
				},
				paperFullWidth: {
					minHeight: '53rem',
					borderRadius: 0,
				},
			},
			MuiDialogActions: {
				root: {
					justifyContent: 'center',
					flexDirection: 'column',
					[props.breakpoints.up('md')]: {
						margin: 0,
					},
				},
				action: {
					width: '100%',
					padding: '2rem',
				},
			},
			MuiDialogContent: {
				root: {
					[props.breakpoints.up('md')]: {
						padding: 0,
					},
				},
			},
			MuiDialogTitle: {
				root: {
					[props.breakpoints.up('md')]: {
						padding: 0,
					},
					'&>h2': {
						marginBottom: '4rem',
					},
				},
			},
			MuiDrawer: {
				paper: {
					padding: '3rem',
					fontFamily: props.defaultContentFont,
					fontSize: '1.8rem',
					color: props.mainMenuColor,
					background: props.mainMenuBackground[500],
					[props.breakpoints.up('md')]: {
						padding: '1.8rem 4rem',
						fontSize: '3rem',
					},
				},
			},
			MuiFab: {
				primary: {
					backgroundColor: black[500],
					color: white[500],
					'&:hover': {
						backgroundColor: black[400],
					},
				},
			},
			MuiFormControl: {
				root: {
					width: '100%',
				},
			},
			MuiFormControlLabel: {
				root: {
					marginRight: '20px',
					width: '40%',
					'@media (min-width: 1400px)': {
						width: 'auto',
						marginRight: '50px',
					},
				},
			},
			MuiFormGroup: {
				root: {
					width: '100%',
					flexDirection: 'row',
				},
			},
			MuiFormHelperText: {
				root: {
					fontSize: '1.25rem',
				},
			},
			MuiFormLabel: {
				root: {
					fontFamily: props.defaultContentFont,
					fontSize: '1.8rem',
					color: props.defaultContentColor[500],
				},
			},
			MuiInput: {
				input: {
					padding: '14px 0',
					fontSize: '1.8rem',
					lineHeight: '3rem',
				},
			},
			MuiInputBase: {
				inputMultiline: {
					minHeight: '14rem',
				},
			},
			MuiMenuItem: {
				root: {
					fontSize: '1.8rem',
				},
			},
			MuiPickersDay: {
				daySelected: {
					'& >*': {
						margin: 0,
						marginTop: '16px',
					},
				},
				day: {
					'& >*': {
						margin: 0,
						marginTop: '16px',
					},
				},
			},
			MuiPickersSlideTransition: {
				transitionContainer: {
					'& >*': {
						top: '-6px',
					},
				},
			},
			MuiSelect: {
				icon: {
					top: 'calc(50% - 10px)',
				},
			},
			MuiStepConnector: {
				root: {
					display: 'none',
				},
			},
			MuiStepIcon: {
				root: {
					transform: 'scale(1.7)',
					margin: '0 10px',
				},
				text: {
					fontSize: '1.2rem',
				},
			},
			MuiStepLabel: {
				iconContainer: {
					padding: '0 20px 0 0',
				},
				labelContainer: {
					display: 'none',
				},
			},
			MuiStepper: {
				root: {
					backgroundColor: 'transparent',
					padding: '0',
					margin: '30px 0',
				},
			},
			MuiSvgIcon: {
				root: {
					width: '2rem',
					height: '2rem',
				},
			},
			MuiTableCell: {
				root: {
					padding: '4px 16px 4px 16px',
				},
				head: {
					border: 0,
					fontSize: '1.2rem',
					color: props.defaultContentColor[500],
					fontFamily: props.defaultTitleFont,
					lineHeight: '2rem',
					letterSpacing: '.4rem',
				},
				body: {
					paddingTop: '1.8rem',
					paddingBottom: '1.8rem',
				},
			},
			MuiTablePagination: {
				caption: {
					fontSize: '1.8rem',
				},
				select: {
					fontSize: '1.8rem',
					lineHeight: '1.8rem',
					paddingRight: 32,
				},
			},
			MuiTypography: {
				root: {
					fontSize: '1.8rem',
				},
				h1: {
					fontFamily: props.defaultTitleFont,
					fontSize: '3rem',
					fontWeight: '500',
					lineHeight: '4.2rem',
					color: props.defaultTitleColor[500],
					marginBottom: '1.4rem',
					letterSpacing: 0,
					[props.breakpoints.up('md')]: {
						fontSize: '7rem',
						lineHeight: '9rem',
						letterSpacing: '1rem',
					},
				},
				h2: {
					fontFamily: props.defaultTitleFont,
					fontSize: '2.75rem',
					lineHeight: 1.25,
					fontWeight: 'bold',
					color: props.defaultContentColor[500],
					letterSpacing: '0.3rem',
					marginBottom: '1.4rem',
					[props.breakpoints.up('md')]: {
						fontSize: '4rem',
						lineHeight: '5rem',
					},
				},
				h3: {
					fontFamily: props.defaultContentFont,
					fontSize: '3rem',
					lineHeight: '150%',
					color: props.defaultContentColor[500],
					fontWeight: 800,
					marginBottom: '1.4rem',
					[props.breakpoints.up('md')]: {
						fontSize: '4rem',
						letterSpacing: '.1rem',
					},
				},
				h4: {
					color: props.defaultContentColor[500],
					fontFamily: props.secondaryTitleFont,
					fontWeight: 500,
					fontSize: '3.6rem',
					lineHeight: '5rem',
					marginBottom: '3.6rem',
					[props.breakpoints.up('md')]: {
						lineHeight: '6rem',
						marginBottom: '4.6rem',
						fontSize: '3.6rem',
					},
				},
				h5: {
					color: props.defaultContentColor[500],
					fontFamily: props.secondaryTitleFont,
					fontSize: '2.6rem',
					fontWeight: 'bold',
					lineHeight: '3.6rem',
					marginBottom: '1.3rem',
					[props.breakpoints.up('md')]: {
						lineHeight: '5.2rem',
						marginBottom: '0rem',
					},
				},
				h6: {
					color: props.defaultContentColor[500],
					fontFamily: props.defaultTitleFont,
					fontSize: '1.8rem',
					fontWeight: 'bold',
					lineHeight: '2rem',
					marginBottom: '1.3rem',
					letterSpacing: '.2rem',
					[props.breakpoints.up('md')]: {
						marginBottom: '1.8rem',
					},
				},
				subtitle1: {
					fontFamily: props.secondaryTitleFont,
					fontSize: '2.2rem',
					lineHeight: '150%',
					color: props.defaultContentColor[500],
					marginBottom: '1.4rem',
					fontWeight: '500',
				},
				subtitle2: {
					fontFamily: props.secondaryTitleFont,
					fontSize: '2.4rem',
					lineHeight: '150%',
					color: props.defaultContentColor[500],
					marginBottom: '1.4rem',
					fontWeight: '500',
					[props.breakpoints.up('md')]: {
						marginBottom: '4rem',
						letterSpacing: '.1rem',
					},
				},
				body1: {
					fontSize: '1.8rem',
					color: props.defaultContentColor[500],
					lineHeight: '3rem',
					marginBottom: '2rem',
					letterSpacing: '0.06rem',
					[props.breakpoints.up('md')]: {
						marginBottom: '3rem',
					},
				},
				body2: {
					fontSmoothing: 'auto',
					color: props.defaultContentColor[500],
					fontSize: '2rem',
					lineHeight: '3.6rem',
					marginBottom: '2rem',
					[props.breakpoints.up('md')]: {
						fontWeight: 400,
					},
				},
				gutterBottom: {
					marginBottom: '3em',
				},
			},
			PrivateValueLabel: {
				label: {
					fontSize: '14px',
				},
			},
			SingleDot: {
				HotspotBlockText: {
					lineHeight: '28px',
				},
			},
		},
	});

export default theme;
